module.exports = __webpack_public_path__ + "img/global.39550600.png";